import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import AuthUtility from './auth/AuthUtility';

import romergence_image from '../../assets/frontend/images/romergence.png';
import to_infinity_square_image from '../../assets/frontend/images/to_infinity_square.png';
import fragments_of_the_mind_square_image from '../../assets/frontend/images/fragments_of_the_mind_square.png';
import fragments_of_the_mind_square_lighter_image from '../../assets/frontend/images/fragments_of_the_mind_square_lighter.png';
import rise_and_fall_square_image from '../../assets/frontend/images/rise_and_fall_square.png';
import to_infinity_and_back_square_image from '../../assets/frontend/images/to_infinity_and_back_square.png';
import between_the_moment_square_image from '../../assets/frontend/images/between_the_moment_square.png';

const About = () => {

	//logout should be its own component
	const navHistory = useNavigate();

	function handleAlbum(title_private, type) {
		if (!title_private || title_private === '' || !type || type === '') {
			return;
		}
		if (AuthUtility.isLoggedIn()) {
			navHistory('/member/album/' + title_private + '/' + type);
		} else {
			//user not authenticated on server so remove from local storage
			AuthUtility.clearAuthData();
			navHistory('/album/' + title_private + '/' + type);
		}
	}

	function handleDonation(title_private, type) {
		if (!title_private || title_private === '' || !type || type === '') {
			return;
		}
		navHistory('/donation/' + title_private + '/' + type);
	}

	function handleJoin() {
		navHistory('/register');
	}

	return (
		<div className="body-content bg-fff pt-70l-110m-50s pb-120">

			<div className="panel large">
				<div className="grid-x">

					<div className="large-12 medium-12 small-12 cell text-center mt-20l-10s">
						<div className="text-overlay-wrapper b2-000 text-center">
							<div className="text-overlay-1020-bottom50">
								<div className="position-align-bottom pb-20 text-center hide-for-small-only">
									<div className="font-orbitron font-size-24 font-weight-800 txt-fff letter-spacing-0px uppercase italic">Romergence</div>
									<div className="font-orbitron font-size-14 font-weight-500 txt-fff letter-spacing-1px italic pt-15">De Ortu Abyssi</div>
								</div>
								<div className="position-align-bottom pb-10 text-center show-for-small-only">
									<div className="font-orbitron font-size-16 font-weight-800 txt-fff letter-spacing-0px uppercase italic">Romergence</div>
									<div className="font-orbitron font-size-11 font-weight-500 txt-fff letter-spacing-1px italic pt-7">De Ortu Abyssi</div>
								</div>
							</div>
							<img src={romergence_image} alt="romergence image" width="100%" />
						</div>
						<div className="mt-20l-10s">
							<div className="font-poppins font-size-18l-16m font-weight-400 justify line-height-120per">
								<span className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic">Romergence</span>
								&nbsp; is a boundary-pushing music label born from the fusion of intellect, emotion, and sonic exploration.
								Inspired by  the name Romero and the concept of emergence-where complex beauty arises from the interaction of
								simple elements-Romergence bridges the personal and the universal. Its catalog weaves together themes of love
								and soul connection (<span className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic">To Infinity & Back</span> ),
								the mysteries of time, space, and consciousness (<span className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic">Fragments Of The Mind</span> ),
								and the cyclical nature of human history (<span className="font-orbitron font-size-18l-16m font-weight-800 letter-spacing-0px uppercase italic">Rise & Fall</span> ).
								Rooted in poetic lyricism, bold concepts, and genre-blending soundscapes, Romergence exists to awaken thought, stir feeling, and resonate at the deepest
								levels of mind, body, and spirit.
							</div>
						</div>
						<div className="horizontal-container pt-20l-10s">
							<span className="align-left">
								<Link to="/register" className="button medium width-120px">Join</Link>
							</span>
							<span className="align-right">
								<Link className="button medium width-120px"
									onClick={() => handleDonation('to_infinity_&_back', 'donation')}>
									Donate
								</Link>
							</span>
						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s mt-10">
						<span className="font-orbitron font-weight-800 font-size-24l-20m-16s letter-spacing-1px uppercase italic">Albums</span>
					</div>

					<div className="large-12 medium-12 small-12 cell mt-20l-10s">
						<div className="grid-x">
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5" onClick={() => handleAlbum('to_infinity', 'album')}>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-botom50">
										<div className="position-align-botom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												To Infinity
											</div>
										</div>
									</div>
									<img src={to_infinity_square_image} className="b2-000 hide-for-small-only" alt="romergeto_infinitynce image" width="100%" />
									<img src={to_infinity_square_image} className="b2-000 show-for-small-only" alt="to_infinity image" width="100%" />
								</div>
								<div className="pt-10 text-center">
									<buton className="buton small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('to_infinity', 'album')}>
										Listen
									</buton>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m pl-0l-5m" onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-botom50">
										<div className="position-align-botom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Framents Of
												<div className='pt-10l-5m'></div>
												The Mind
											</div>
										</div>
									</div>
									<img src={fragments_of_the_mind_square_lighter_image} className="b2-000 hide-for-small-only" alt="fragments_of_the_mind image" width="100%" />
									<img src={fragments_of_the_mind_square_lighter_image} className="b2-000 show-for-small-only" alt="fragments_of_the_mind image" width="100%" />
								</div>
								<div className="pt-10 text-center">
									<buton className="buton small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('fragments_of_the_mind', 'demos')}>
										Listen
									</buton>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5" onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
								<div className="pt-20 show-for-1020px">&nbsp;</div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-botom50">
										<div className="position-align-botom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												To Infinity
												<div className='pt-10l-5m'></div>
												& Back
											</div>
										</div>
									</div>
									<img src={to_infinity_and_back_square_image} className="b2-000 hide-for-small-only" alt="to_infinity_and_back image" width="100%" />
									<img src={to_infinity_and_back_square_image} className="b2-000 show-for-small-only" alt="to_infinity_and_back image" width="100%" />
								</div>
								<div className="pt-10 text-center">
									<buton className="buton small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('to_infinity_and_back', 'album')}>
										Listen
									</buton>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('rise_and_fall', 'demos')}>
								<div className="pt-20 show-for-1020px">&nbsp;</div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-botom50">
										<div className="position-align-botom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Rise & Fall
											</div>
										</div>
									</div>
									<img src={rise_and_fall_square_image} className="b2-000 hide-for-small-only" alt="rise_and_fall image" width="100%" />
									<img src={rise_and_fall_square_image} className="b2-000 show-for-small-only" alt="rise_and_fall image" width="100%" />
								</div>
								<div className="pt-10 text-center">
									<buton className="buton small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('rise_and_fall', 'demos')}>
										Listen
									</buton>
								</div>
							</div>
							<div className="large-3 medium-6 small-6 cell album-hover hover-opacity-75 plr-5l-0m" onClick={() => handleAlbum('between_the_moment', 'album')}>
								<div className="pt-20 show-for-1020px">&nbsp;</div>
								<div className="text-overlay-wrapper text-center">
									<div className="text-overlay-1020-botom50">
										<div className="position-align-botom pb-10 text-center">
											<div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
												Between The
												<div className="pt-10l-5m"></div>
												Moment
											</div>
										</div>
									</div>
									<img src={between_the_moment_square_image} className="b2-000 hide-for-small-only" alt="between_the_moment image" width="100%" />
									<img src={between_the_moment_square_image} className="b2-000 show-for-small-only" alt="between_the_moment image" width="100%" />
								</div>
								<div className="pt-10 text-center">
									<buton className="buton small width-80pxl-70pxm-80pxs plr-20"
										onClick={() => handleAlbum('between_the_moment', 'album')}>
										Listen
									</buton>
								</div>
							</div>
						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
						<div className="horizontal-container">
							<span className="align-left">
								<Link to="/register" className="button medium width-120px">Join</Link>
							</span>
							<span className="align-right">
								<Link className="button medium width-120px"
									onClick={() => handleDonation('to_infinity_&_back', 'donation')}>
									Donate
								</Link>
							</span>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
}

export default About;